import * as React from 'react';

import { Link } from 'react-router-dom';

import styled, { css } from 'styled-components';

import Button from '@components/actions/button';
import Typography from '@components/basics/typography';

export interface NavbarItemProps {
  className?: string;
  children?: any;
  isButton?: boolean;
  isActive?: boolean;
  btnRed?: boolean;
  underlineLink?: boolean;
  disabled?: boolean;
  to: string;
  isBig?: boolean;
  cointainer?: React.FC;
}

export const NavbarItem: React.FC<NavbarItemProps> = (props) => {
  const Container = props.cointainer ? props.cointainer : Link;

  return (
    <Container
      to={props.to}
      className={`navbar-item ${props.className} ${
        props.isActive ? 'active' : ''
      }`}
    >
      <span>
        {!props.isButton ? (
          <NavbarItemTypography
            className="text"
            opacity={props.disabled ? '.25' : '1'}
          >
            {props.children}
          </NavbarItemTypography>
        ) : (
          <Button small buttonType={props.btnRed ? 'primary' : 'secondary'}>
            {props.children}
          </Button>
        )}
      </span>
    </Container>
  );
};

export default styled(NavbarItem)`
  margin-bottom: 10px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  @media ${({ theme }) => theme.device.tablet} {
    height: 100%;
    width: auto;
    margin-bottom: 0;
    margin-right: 36px;
    align-items: center;
    justify-content: center;
  }

  ${(props) =>
    props.isBig
      ? css`
          padding: 16px 20px;
          margin-bottom: 0;
        `
      : null}

  ${(props) =>
    props.underlineLink
      ? css`
          margin-right: 0;

          @media ${({ theme }) => theme.device.tablet} {
            padding: 0 10px;
            margin-right: 20px;
          }
        `
      : null}

  ${(props) =>
    props.underlineLink && !props.disabled
      ? css`
          @media ${({ theme }) => theme.device.tablet} {
            &:after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              opacity: 0;
              background-color: ${({ theme }) => theme.colors.primary};
              height: 2px;
              width: 0px;
              transition: width
                  ${({ theme }) =>
                    `${theme.transitions.duration} ${theme.transitions.curve}`},
                opacity
                  ${({ theme }) =>
                    `${theme.transitions.duration} ${theme.transitions.curve}`};
            }

            &.active,
            &:hover {
              .text {
                color: ${({ theme }) => theme.colors.primary};
              }

              &:after {
                width: 100%;
                opacity: 1;
              }
            }
          }
        `
      : null}

  ${(props) =>
    props.disabled
      ? css`
          cursor: default;
          pointer-events: none;

          .text,
          a {
            cursor: default;
          }

          .text {
            &:hover {
              opacity: 0.5;
            }
          }
        `
      : null}
`;

const NavbarItemTypography = styled(Typography)`
  display: flex;
  align-items: center;
  height: 100%;
  font-size: ${({ theme }) => theme.typography.h3};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};

  @media ${({ theme }) => theme.device.tablet} {
    color: ${({ theme }) => theme.colors.tertiary};
    font-size: ${({ theme }) => theme.typography.h4};
    transition: color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.curve}`};

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  a {
    display: flex;
    align-items: center;
    height: 100%;
  }
`;
